export const SELECT_SINGLE = 0
export const SELECT_MULTI = 1